<reports-menu> </reports-menu>

<hr>
<h4 class="hide-on-print">{{ 'DELETED_USERS' | translate}}</h4>
<form [formGroup]="searchForm" (ngSubmit)="getDeletedUsers()" class="hide-on-print">
  <div class="row">
    <div class="form-group col-md-12">
      <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" id="no" value="no" name="filter" formControlName="filter"
          class="custom-control-input" [checked]="true">
        <label class="custom-control-label" for="no">{{ 'ALL' | translate}}</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" id="yes" value="yes" name="filter" formControlName="filter"
          class="custom-control-input">
        <label class="custom-control-label" for="yes">{{ 'FILTER_BY_DATE' | translate}}</label>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="this.searchForm.value.filter == 'yes'">
    <div class="form-group col-md-6">
      <label for="datefrom">{{ 'DATE_FROM' | translate}}</label>
      <div class="input-group mb-3">
        <p-calendar #calendar class="form-control" name="datefrom" formControlName="datefrom"
          dateFormat="dd-mm-yy" [locale]="locale.localeObject"
          [inputStyle]="{'border':'none', 'font-size': '1em', 'padding': 'initial'}">
        </p-calendar> <button class="btn btn-outline-secondary fas fa-calendar-alt"
          (click)="calendar.showOverlay()" type="button"></button>
      </div>
    </div>
    <div class="form-group col-md-6">
      <label for="dateto">{{ 'DATE_TO' | translate}}</label>
      <div class="input-group mb-3">
        <p-calendar #calendar2 class="form-control" name="dateto" formControlName="dateto"
          dateFormat="dd-mm-yy" [locale]="locale.localeObject"
          [inputStyle]="{'border':'none', 'font-size': '1em', 'padding': 'initial'}">
        </p-calendar> <button class="btn btn-outline-secondary fas fa-calendar-alt"
          (click)="calendar2.showOverlay()" type="button"></button>
      </div>
    </div>
  </div>
  <div class="form-group row margin-top">
    <div class="form-group col-md-6">
      <button type="submit" class="btn btn-main-color btn-block">
        {{ 'SEARCH' | translate}}
      </button>
    </div>
    <div class="col-md-6">
      <button type="reset" class="btn btn-secondary-color btn-block" (click)="clearDeletedUsers()">
        {{ 'RESET' | translate}}
      </button>
    </div>
  </div>
</form>

<div class="text-center alert background-main-color" *ngIf="_resourceService.loading">
  <i class="fa fa-refresh fa-spin font-size-20"></i>
  <span> {{ 'LOADING' | translate }}...</span>
</div>

<div *ngIf="deletedUsers?.length && !_resourceService.loading">

  <div class="container hide-on-print">
    <div class="row">
      <div class="col">
        <h4>&nbsp;</h4>
      </div>
      <div class="float-right">
        <button class="btn btn-secondary-color btn-sm" (click)="print()">{{
                        'PRINT' | translate }}</button>
      </div>
    </div>
  </div>

  <p-table [value]="deletedUsers" sortField="deletedDate" [sortOrder]="-1" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="deletedDate">
          {{ 'DELETED_DATE' | translate}}<p-sortIcon field="deletedDate"></p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="patnr">{{ 'PATNR' | translate}}<p-sortIcon field="patnr">
          </p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="nhsNumber">{{ 'EXTNR' | translate}}<p-sortIcon
            field="nhsNumber">
          </p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="name">{{ 'NAME' | translate}}<p-sortIcon field="name">
          </p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="lastname">{{ 'LASTNAME' | translate}}<p-sortIcon
            field="lastname">
          </p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="email">{{ 'EMAIL' | translate}}<p-sortIcon field="email">
          </p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-deletedUser>
      <tr>
        <td>{{deletedUser.deletedDate | slice:0:10}}</td>
        <td>{{deletedUser.patnr}}</td>
        <td>{{deletedUser.nhsNumber}}</td>
        <td>{{deletedUser.name}}</td>
        <td>{{deletedUser.lastname}}</td>
        <td>{{deletedUser.email}}
      </tr>
    </ng-template>
  </p-table>
</div>